import SweetScroll from "sweet-scroll";
export var initSidebar = function initSidebar() {
  var targetNode = document.querySelector(".private-popup");
  if (!targetNode) return;
  var scroller = new SweetScroll({
    easing: "easeOutSine",
    offset: -130,
    preventDefault: false
  });
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        if (mutation.target.classList.contains("is-disabled")) {
          var hash = window.location.hash;
          var needsInitialScroll = document.getElementById(hash.substr(1)) != null;

          if (needsInitialScroll) {
            window.location.hash = "";
          }

          setTimeout(function () {
            scroller.to(hash, {
              updateURL: "replace"
            });
          }, 500);
        }
      }
    });
  });
  observer.observe(targetNode, {
    attributes: true
  });
  var allSectionsTitles = document.querySelectorAll(".sticky-nav");
  if (allSectionsTitles.length < 1) return;
  var sidebar = document.querySelector(".sidebar");
  if (!sidebar) return;
  allSectionsTitles.forEach(function (item) {
    var sidebarItem = document.createElement("a");
    sidebarItem.appendChild(document.createTextNode(item.textContent));
    sidebarItem.classList.add("sidebar__link");
    sidebarItem.setAttribute("href", "#".concat(item.getAttribute("id")));
    sidebar.appendChild(sidebarItem);
  });
  var sidebarButtons = sidebar.getElementsByClassName("sidebar__link");
  Array.from(sidebarButtons).forEach(function (btn, index) {
    btn.addEventListener("click", function () {
      scroller.toElement(allSectionsTitles[index]);
    });
  });
};